import { useDispatch } from "react-redux";
import { removeRoute } from "../../../reducers/routeManagement/thunkActions";
import { Modal } from "../Modal";
import { RemoveRouteContent } from "./RemoveRouteContent";
import { RemoveRouteActions } from "./RemoveRouteActions";

export const RemoveRouteModal = ({ onClose, route }) => {
  const dispatch = useDispatch();

  const onContinue = async () => {
    const { error } = await dispatch(removeRoute(route));
    !error && onClose();
  };

  return (
    <Modal
      open={true}
      onClose={onClose}
      title={"Remove Route"}
      content={<RemoveRouteContent route={route} />}
      actions={
        <RemoveRouteActions onCancel={onClose} onContinue={onContinue} />
      }
      maxWidth={"sm"}
    />
  );
};
